export default function Method() {
  const steps = [
    {
      number: 1,
      title: 'Audit',
      description: 'Inspection complète de votre bien avec documentation photographique détaillée.',
      icon: 'ri-search-eye-line'
    },
    {
      number: 2,
      title: 'Rapport',
      description: 'Présentation d\'un rapport d\'état et recommandations personnalisées.',
      icon: 'ri-file-text-line'
    },
    {
      number: 3,
      title: 'Gestion',
      description: 'Mise en place du plan de gestion adapté à vos besoins spécifiques.',
      icon: 'ri-settings-3-line'
    },
    {
      number: 4,
      title: 'Reporting mensuel',
      description: 'Envoi régulier de rapports détaillés avec preuves visuelles et financières.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: 5,
      title: 'Sérénité',
      description: 'Vous profitez de votre bien en toute tranquillité, où que vous soyez.',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="methode" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3B5C] mb-4">
            Un Processus Rigoureux
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            De l'audit initial à votre sérénité totale, chaque étape est pensée pour votre tranquillité d'esprit.
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-20 left-0 right-0 h-1 bg-gradient-to-r from-[#1A3B5C] via-[#C9A961] to-[#C9A961]"></div>

          <div className="grid md:grid-cols-5 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex flex-col items-center text-center">
                  <div
                    className={`w-16 h-16 rounded-full flex items-center justify-center text-white text-2xl font-bold mb-6 relative z-10 ${
                      index === 4 ? 'bg-[#C9A961] shadow-lg shadow-[#C9A961]/50' : 'bg-[#1A3B5C]'
                    }`}
                  >
                    {step.number}
                  </div>

                  <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 w-full">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4">
                      <i className={`${step.icon} text-[#C9A961] text-4xl`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-[#1A3B5C] mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            Notre méthode garantit une gestion transparente et professionnelle de votre patrimoine immobilier.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="inline-flex items-center space-x-2 text-[#1A3B5C] font-semibold text-lg hover:text-[#C9A961] transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>Découvrir notre charte qualité</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
